module.exports = __webpack_public_path__ + "static/html-element_6-44ae36b0307d73b7844705d0c9dda08d.jpg";